import React from 'react';
import { mainNav } from '../../data/data';

interface ComponentProps {
  // Add your props here
}

const Navigation: React.FC<ComponentProps> = () => {
  return (
    <div className="hidden md:flex space-x-6">
        {mainNav.map(({ title, target }) => (
            <a key={target} href={`#${target}`}
              className="hover:text-blue-200 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-300 rounded px-2 py-1"
              aria-label={`Navigate to ${title} section`} >
              {title}
            </a>
        ))}
    </div>
  );
};

export default Navigation;
